import { dateFormatMap, dateformats } from "./helpers";
import Papa from "papaparse";
import { parse, isValid, format as formatDate } from "date-fns";
export const columnDataTypesOptions = [
  { label: "Text", value: "1" },
  { label: "Numeric", value: "2" },
  { label: "Date", value: "3" },
];

export const sortObjectByKeys = (obj) => {
  return Object.fromEntries(
    Object.entries(obj).sort(([keyA], [keyB]) => keyA.localeCompare(keyB)),
  );
};

export function identifyDate(input) {
  input = input.trim();
  for (let format of dateformats) {
    const parsedDate = parse(input, format, new Date());
    if (isValid(parsedDate)) {
      return parsedDate;
    }
  }
}
export function getKeyByValue(object, value) {
  return Object.entries(object).find(([key, val]) => val === value)?.[0];
}
export const getMaxColumnLenght = (worksheet) => {
  let maxDataCount = 0;
  let all_col = worksheet._columns;
  all_col.forEach((col) => {
    let colvalues = worksheet.getColumn(col._number).values;
    if (colvalues.length > maxDataCount) {
      maxDataCount = colvalues.length;
    }
  });

  return {
    length: maxDataCount,
  };
};

export const create_unique_key = (rule, groupByColumns, i, inputColsData) => {
  const key = rule.grpByCol
    .map((ccol, index) => {
      // let ifFound = inputColsData.find((chr) => chr.inColChr === ccol);
      // if (ifFound.inColDT === "3") {
      //   return dateFormatMap[ifFound.mask](new Date(groupByColumns[index][i]));
      // }
      return groupByColumns[index][i];
    })
    .join("*");
  return key;
};

function combineDataByRules(
  data,
  cmbData,
  groupByCols,
  combineColIndex,
  sumColIndex,
) {
  // Create a map to hold combined data based on the specified keys
  const combinedDataMap = {};
  // sort data

  for (let j = 0; j < data[0].length; j++) {
    const baseKey = groupByCols.map((colIndex) => data[colIndex][j]).join("-");
    // Get the current payment column value
    const columnValue = data[combineColIndex][j];

    if (combinedDataMap[baseKey]) {
      combinedDataMap[baseKey].push({
        date: data[0][j],
        amount: data[sumColIndex][j],
        paymentType: columnValue,
      });
    }

    if (!combinedDataMap[baseKey]) {
      combinedDataMap[baseKey] = [
        {
          date: data[0][j],
          amount: data[sumColIndex][j],
          paymentType: columnValue,
        },
      ];
    }
  }
  let output = combinePaymentsByRule(combinedDataMap, cmbData);
  return output;
}

// works for single array rule
function combinePaymentsByRule(data, cmbData) {
  // Extract the combination rule
  const comboKey = cmbData[0][2];
  const comboTypes = cmbData[0].slice(0, 2); // ["Visa", "Master"]

  // Iterate over each date in the data object
  for (const date in data) {
    let combinedAmount = 0;
    const newEntries = [];

    // Iterate over each entry in the array for this date
    data[date].forEach((entry) => {
      if (comboTypes.includes(entry.paymentType)) {
        combinedAmount += entry.amount;
      } else {
        // Add non-combo entries to newEntries array
        newEntries.push(entry);
      }
    });

    // If combinedAmount is greater than 0, add the combined entry
    if (combinedAmount > 0) {
      newEntries.push({
        date,
        amount: parseFloat(combinedAmount.toFixed(1)),
        paymentType: comboKey,
      });
    }

    // Replace the entries for this date with the new array
    data[date] = newEntries;
  }

  return data;
}

export const getColumnHeader = (worksheet, chr) => {
  const header = worksheet.getColumn(chr).values[1];
  return header;
};

export const getColumnData = (worksheet, chr, sliceIndex = 2) => {
  const col = worksheet
    .getColumn(chr)
    .values.slice(sliceIndex)
    .filter((val, index) => val !== undefined && val !== null && val !== ""); // Column P (payment_type)

  return col;
};
export const getColumnDataWithBlankSpaces = (
  worksheet,
  chr,
  sliceIndex = 2,
) => {
  return worksheet.getColumn(chr).values.slice(sliceIndex);
};
export const prepareWorkSheetFromCSVFilePapaParser = (
  csvData,
  worksheet,
  setParsedCSV,
) => {
  // Parse CSV using Papa Parse
  const { data, errors } = Papa.parse(csvData, {
    skipEmptyLines: true, // Skip empty rows
    dynamicTyping: false, // Keep all data as strings
  });

  if (errors.length) {
    console.error("Errors while parsing CSV:", errors);
  } else {
    // convert parsed objects into an array
    const parsedData = data.map((row) => Object.values(row));
    setParsedCSV(parsedData);
  }
  // Add rows to the worksheet
  data.forEach((row, i) => {
    worksheet.addRow(row.map((value) => value?.trim() || "")); // Trim and add rows
  });

  return worksheet;
};

export const prepareWorkSheetFromCSVFile = (csvData, worksheet) => {
  const rows = csvData.split("\n").map((row) => row.split(","));
  rows.forEach((row, rowIndex) => {
    worksheet.addRow(row);
  });
  return worksheet;
};

export const matchInputDataType = (cell, rule) => {
  switch (rule.findType) {
    case "3": // Date
      return typeof cell === "string" && identifyDate(cell);

    case "2": //  Number
      if (!isNaN(Number(cell)) && cell === rule.searchValue) {
        return true;
      }
      return false;

    case "1": // Text
      if (rule.searchValue === "") {
        return false;
      }

      return (
        typeof cell === "string" &&
        cell.trim() !== "" &&
        cell === rule.searchValue
      );

    default:
      return false;
  }
};

export const setHeaderToOutputColumns = (outputSheet, outputColumns, cols) => {
  cols.forEach((col) => {
    let found = outputColumns.find((fcol) => fcol.outColChr === col);
    outputSheet.getCell(`${col}${1}`).value = found.outputColumnHeader;
  });
  return outputSheet;
};
export const applyOutputFileSettings = (
  outputSheet,
  outputFileSettings,
  fileName,
) => {
  autoTruncate(outputSheet, outputFileSettings);
  removeDuplicateRows(outputSheet, outputFileSettings);
  downloadWorksheetAsCSV(outputSheet, outputFileSettings?.rowsToSkip, fileName);
};

const autoTruncate = (outputSheet, outputFileSettings) => {
  if (
    !outputFileSettings?.autoTruncate ||
    !outputFileSettings?.truncatingColumn
  )
    return;
  // find the length of the column, then remove all the rows after this lenght from the outputsheet.
  const colValues = outputSheet
    .getColumn(outputFileSettings.truncatingColumn)
    .values.slice(2);

  // Calculate the first row that should be deleted
  // If colValues.length is 3, then 3 + 2 = 5. Row 5 is the first "empty" row.
  const startDeletionAt = colValues.length + 2;
  const totalRows = outputSheet.rowCount;

  // IMPORTANT: Loop backwards from the end of the sheet to the start row
  for (let i = totalRows; i >= startDeletionAt; i--) {
    outputSheet.spliceRows(i, 1);
  }
};
/**
 * Removes duplicate rows from the outputSheet based on user settings.
 * @param {Object} outputSheet - The ExcelJS worksheet object.
 * @param {Object} settings - The outputFileSettings object.
 */
export const removeDuplicateRows = (outputSheet, settings) => {
  if (!settings?.removeDuplicateRows) return;

  const { removeDuplicateRows, columnsToAvoidInDuplicateCheck } = settings;

  if (!removeDuplicateRows) return;

  const seenRows = new Set();
  const rowsToDelete = [];

  const ignoredCols = new Set(
    columnsToAvoidInDuplicateCheck?.map((col) => col.value) || [],
  );

  // 1. Start from row 2 (Row 1 is Header, Index 0 is null)
  // rowCount is 1-based in ExcelJS
  const totalRows = outputSheet.rowCount;
  const totalCols = outputSheet.columnCount;

  for (let rowNumber = 2; rowNumber <= totalRows; rowNumber++) {
    const rowData = [];

    // 2. Use a fixed loop for columns to ensure the fingerprint structure is identical
    for (let colNumber = 1; colNumber <= totalCols; colNumber++) {
      const column = outputSheet.getColumn(colNumber);
      // Check if this column should be ignored
      if (ignoredCols.has(column.letter)) {
        continue;
      }

      const cell = outputSheet.getCell(`${column.letter}${rowNumber}`);
      const val =
        cell.value !== null && cell.value !== undefined
          ? String(cell.value).trim()
          : "";
      rowData.push(val);
    }

    // 3. Create fingerprint
    const rowHash = JSON.stringify(rowData);

    if (seenRows.has(rowHash)) {
      rowsToDelete.push(rowNumber);
    } else {
      seenRows.add(rowHash);
    }
  }

  // 4. Reverse Delete to maintain index integrity
  for (let i = rowsToDelete.length - 1; i >= 0; i--) {
    outputSheet.spliceRows(rowsToDelete[i], 1);
  }
};
export const downloadWorksheetAsCSV = async (
  worksheet,
  rowsToSkip,
  filename,
) => {
  const rows = [];
  const maxColumns = worksheet.columnCount;
  let currentRowIndex = 0;
  worksheet.eachRow((row, rowNumber) => {
    const rowData = new Array(maxColumns).fill("");
    row.eachCell((cell, colNumber) => {
      rowData[colNumber - 1] = cell.value;
    });
    if (rowsToSkip > 0) {
      rows[currentRowIndex] = rowData;
      currentRowIndex += rowsToSkip + 1;
    } else {
      rows.push(rowData);
    }
  });
  download_csv(rows, filename);
};

export const download_csv = (rows, fileName) => {
  // Prepare the CSV data for download, quoting/escaping fields as needed
  // (commas, quotes, newlines) so values round-trip correctly on re-import.
  const csvOutputData = Papa.unparse(rows);

  // Specify the filename for the download
  if (fileName === "") {
    fileName = "outputFile";
  }
  const extension = fileName.split(".")[1];
  if (fileName.includes("_")) {
    fileName = fileName.split("_")[0] + `_OutputFile.${extension || "csv"}`;
  }

  // Create a Blob from the CSV string
  const blob = new Blob([csvOutputData], {
    type: "text/csv;charset=utf-8;",
  });

  // Create a URL for the Blob
  const url = URL.createObjectURL(blob);

  // Create a temporary anchor element for downloading
  const a = document.createElement("a");
  a.href = url;
  a.download = fileName; // Set the desired file name
  document.body.appendChild(a);
  a.click(); // Trigger the download
  document.body.removeChild(a); // Clean up the DOM
  URL.revokeObjectURL(url); // Release the blob UR
};

export function parseCustomDate(dateStr, inputFormat) {
  const parsedDate = parse(dateStr, inputFormat, new Date());

  if (!isValid(parsedDate)) {
    throw new Error(
      `Invalid date or format: "${dateStr}" with format "${inputFormat}"`,
    );
  }

  // Return the formatted date as ddMMyy
  return formatDate(parsedDate, "ddMMyy");
}
export function removeDateSeparators(dateStr) {
  return dateStr.replace(/[^0-9A-Za-z]/g, ""); // Removes only separators
}

// insert start date or end date or  date range
export const insertDateRange = (rule, dataRow, dataKey) => {
  const dateObj = dataRow[dataKey] || {};
  switch (rule?.weeklyDateTypeToInsert) {
    case "startDate":
      return dateObj.startDate || "";
    case "endDate":
      return dateObj.endDate || "";
    case "dateRange":
      if (dateObj.startDate && dateObj.endDate) {
        return `${dateObj.startDate.replace(
          /\D/g,
          "",
        )} - ${dateObj.endDate.replace(/\D/g, "")}`; // convert to format given in lazada
      }
      return "";
    default:
      return "";
  }
};

export const createExecutionSummary = () => {
  return {
    fileName: "",
    startTime: new Date(),
    endTime: null,
    executionTimeInMs: 0,
    totalRowsProcessed: 0,

    inputColumnValidation: null,

    // Column processing summary
    InputColumnProcessing: {
      replacements: [],
      dateConversions: [],
      absoluteConversions: [],
      integerConversions: [],
      negateConversions: [],
      totalChanges: 0,
    },

    OutputColumns: {
      customeDataColumns: [],
      cloneColumns: [],
    },

    // Rules execution summary
    rulesExecution: {
      totalRules: 0,
      successfulRules: 0,
      failedRules: 0,
      executedRules: [],
    },

    sorting: {
      operations: [],
      totalOperations: 0,
      totalRowsAffected: 0,
    },

    // Row removal summary
    rowRemoval: {
      operations: [],
      totalRowsRemoved: 0,
    },
  };
};

export const validateInputColumns = (worksheet, inputColumns, headerRow) => {
  const validationResults = {
    validColumns: [],
    emptyColumns: [],
    invalidColumns: [],
    warnings: [],
    totalRows: worksheet.rowCount,
  };

  inputColumns.forEach((columnConfig) => {
    const columnLetter = columnConfig.inColChr; // e.g., "A", "B", etc.

    // Check if column exists and has data
    let hasData = false;
    let sampleData = [];

    try {
      // Check first few rows to see if column has any data
      for (let i = headerRow + 1; i <= worksheet.rowCount; i++) {
        const cellValue = worksheet.getCell(`${columnLetter}${i}`).value;
        if (cellValue !== null && cellValue !== undefined && cellValue !== "") {
          hasData = true;
          // Collect up to 3 sample values for preview
          if (sampleData.length < 3) {
            sampleData.push(cellValue);
          }
          // Break early once we confirm the column has data
          if (sampleData.length >= 3) {
            break;
          }
        }
      }

      const columnValidation = {
        columnLetter,
        hasData,
        sampleData,
        appliedRules: [],
      };

      // Check what rules are applied to this column
      if (columnConfig.replaceColumnData)
        columnValidation.appliedRules.push("Replace Data");
      if (columnConfig.toDateFormat)
        columnValidation.appliedRules.push("Date Format Conversion");
      if (columnConfig.makeColumnAbsolute)
        columnValidation.appliedRules.push("Make Absolute");
      if (columnConfig.makeItInteger)
        columnValidation.appliedRules.push("Convert to Integer");

      if (hasData) {
        validationResults.validColumns.push(columnValidation);
      } else {
        validationResults.emptyColumns.push(columnValidation);
        validationResults.warnings.push(
          `Column ${columnLetter} is defined but has no data${
            columnValidation.appliedRules.length > 0
              ? ` and has ${
                  columnValidation.appliedRules.length
                } rule(s) applied: ${columnValidation.appliedRules.join(", ")}`
              : ""
          }`,
        );
      }
    } catch (error) {
      validationResults.invalidColumns.push({
        columnLetter,
        error: error.message,
      });
    }
  });

  return validationResults;
};

// Helper function to read file as text
export const readFileAsText = (file) => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = (e) => resolve(e.target.result);
    reader.onerror = (e) => reject(e);
    reader.readAsText(file);
  });
};

// Helper function to extract Excel rows
export const extractExcelRows = (worksheet) => {
  let maxColumns = 0;
  worksheet.eachRow((row) => {
    maxColumns = Math.max(maxColumns, row.cellCount);
  });

  const extractedRows = [];
  worksheet.eachRow((row) => {
    const plainValues = Array.from({ length: maxColumns }, (_, colIndex) => {
      const cell = row.getCell(colIndex + 1).value; // 1-based index
      if (cell instanceof Date) {
        return cell.toLocaleDateString(); // Format Date
      }
      if (cell && typeof cell === "object" && "result" in cell) {
        return cell.result; // Handle formulas
      }
      return cell ?? ""; // Empty cells are filled with an empty string
    });
    extractedRows.push(plainValues);
  });

  return extractedRows;
};

export const displayImage = (img) => {
  // 1. Handle Null/Empty
  if (!img) {
    return "https://www.gravatar.com/avatar/00000000000000000000000000000000?d=mp&f=y";
  }

  // 2. Handle File Paths or full URLs (e.g., "profile-pictures/123.png")
  // If it doesn't look like a Base64 string and is a string, it's a path.
  if (
    typeof img === "string" &&
    !img.startsWith("UklGR") &&
    !img.startsWith("data:")
  ) {
    // If you use a storage bucket, prefix it: return `https://your-s3-bucket.com/${img}`;
    return img;
  }

  // 3. Handle Raw Base64 Strings (like User 1 in your array)
  // WebP images often start with 'UklGR'
  if (
    typeof img === "string" &&
    (img.startsWith("UklGR") || img.length > 100)
  ) {
    return `data:image/webp;base64,${img}`;
  }

  // 4. Handle MongoDB Buffer Objects { data: [...], type: 'Buffer' }
  try {
    const bufferSource = img.data ? img.data : img;
    const uint8 = new Uint8Array(bufferSource);

    let binary = "";
    for (let i = 0; i < uint8.length; i++) {
      binary += String.fromCharCode(uint8[i]);
    }

    return `data:image/webp;base64,${btoa(binary)}`;
  } catch (e) {
    return "https://www.gravatar.com/avatar/00000000000000000000000000000000?d=mp&f=y";
  }
};
